var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddCommentImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gallllery/32px/edit image"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 12C28 14.2091 26.2091 16 24 16C21.7909 16 20 14.2091 20 12C20 9.79086 21.7909 8 24 8C26.2091 8 28 9.79086 28 12ZM26.2 12C26.2 13.215 25.215 14.2 24 14.2C22.785 14.2 21.8 13.215 21.8 12C21.8 10.785 22.785 9.8 24 9.8C25.215 9.8 26.2 10.785 26.2 12Z",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4C1.34315 4 0 5.34315 0 7V25C0 26.6569 1.34315 28 3 28H29C30.6569 28 32 26.6569 32 25V7C32 5.34315 30.6569 4 29 4H3ZM29 5.8H3C2.33726 5.8 1.8 6.33726 1.8 7V23.663L9.67705 14.3634C10.4595 13.4397 11.8948 13.4735 12.6329 14.433L17.4869 20.7436C17.5203 20.7871 17.5826 20.7955 17.6264 20.7624L20.5608 18.548C21.2453 18.0314 22.191 18.0374 22.8689 18.5626L30.2 24.2418V7C30.2 6.33726 29.6627 5.8 29 5.8ZM3 26.2C2.71155 26.2 2.44686 26.0982 2.2399 25.9286L11.0506 15.5268C11.0917 15.4782 11.1673 15.48 11.2061 15.5305L16.0601 21.841C16.6958 22.6673 17.8785 22.8272 18.7106 22.1992L21.6451 19.9848C21.6811 19.9576 21.7309 19.9579 21.7666 19.9856L29.5893 26.0456C29.4152 26.1439 29.2142 26.2 29 26.2H3Z",
    fill: "#909090"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCommentImage);
export default __webpack_public_path__ + "static/media/add_comment_image.97e9ce03.svg";
export { ForwardRef as ReactComponent };var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddCommentImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gallllery/32px/edit image"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 12C28 14.2091 26.2091 16 24 16C21.7909 16 20 14.2091 20 12C20 9.79086 21.7909 8 24 8C26.2091 8 28 9.79086 28 12ZM26.2 12C26.2 13.215 25.215 14.2 24 14.2C22.785 14.2 21.8 13.215 21.8 12C21.8 10.785 22.785 9.8 24 9.8C25.215 9.8 26.2 10.785 26.2 12Z",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4C1.34315 4 0 5.34315 0 7V25C0 26.6569 1.34315 28 3 28H29C30.6569 28 32 26.6569 32 25V7C32 5.34315 30.6569 4 29 4H3ZM29 5.8H3C2.33726 5.8 1.8 6.33726 1.8 7V23.663L9.67705 14.3634C10.4595 13.4397 11.8948 13.4735 12.6329 14.433L17.4869 20.7436C17.5203 20.7871 17.5826 20.7955 17.6264 20.7624L20.5608 18.548C21.2453 18.0314 22.191 18.0374 22.8689 18.5626L30.2 24.2418V7C30.2 6.33726 29.6627 5.8 29 5.8ZM3 26.2C2.71155 26.2 2.44686 26.0982 2.2399 25.9286L11.0506 15.5268C11.0917 15.4782 11.1673 15.48 11.2061 15.5305L16.0601 21.841C16.6958 22.6673 17.8785 22.8272 18.7106 22.1992L21.6451 19.9848C21.6811 19.9576 21.7309 19.9579 21.7666 19.9856L29.5893 26.0456C29.4152 26.1439 29.2142 26.2 29 26.2H3Z",
    fill: "#909090"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCommentImage);
export default __webpack_public_path__ + "static/media/add_comment_image.97e9ce03.svg";
export { ForwardRef as ReactComponent };